import React, { PureComponent } from 'react'
import Input from '../../Form/Input'
import activityTrackingService from '../../../../services/activityTrackingService'
import PropTypes from 'prop-types'

/**
 * InputTracked tracks changes in the input value and triggers a trackEvent,
 * when the input field loses focus
 */
class InputTracked extends PureComponent {

  onFocusStartValue = ''

  onBlur = (e) => {
    const { onBlur, eventName, eventOpts, value } = this.props
    const valueChanged = value !== this.onFocusStartValue
    valueChanged && activityTrackingService.trackEvent(eventName, eventOpts)
    onBlur && onBlur(e)
  }

  onFocus = (e) => {
    const { onFocus, value } = this.props
    this.onFocusStartValue = value ?? ''
    onFocus && onFocus(e)
  }

  render () {
    const parentProps = { ...this.props }
    delete parentProps.eventName
    delete parentProps.eventOpts
    return (
      <Input {...parentProps} onFocus={this.onFocus} onBlur={this.onBlur}/>
    )
  }
}

InputTracked.defaultProps = Input.defaultProps
InputTracked.propTypes = {
  ...Input.propTypes,
  eventName: PropTypes.string.isRequired,
  eventOpts: PropTypes.object.isRequired
}
export default InputTracked
